import dayjs, { time2utc, } from '@zenlayer/zen-design/esm/_util/day';
import { dataListener_showUtc } from './index';
// 方法用于比较两个时间，返回[早,晚]的时间
export const compareTimes = (time1, time2) => {
    if (time1.isBefore(time2)) {
        return [time1, time2];
    }
    else {
        return [time2, time1];
    }
};
export const adjustDate = ((opts) => {
    const { datetime, showUTC = dataListener_showUtc.getValue(), trim, subtract, earliestTime, latestTime, returnString, } = opts;
    let d = dayjs(datetime).tz(showUTC ? 'UTC' : dayjs.tz.guess(), true);
    if (subtract) {
        d = d.subtract(subtract?.value, subtract?.unit);
    }
    if (trim === 'dayStart') {
        d = d.startOf('day');
    }
    else if (trim === 'dayEnd') {
        d = d.endOf('day');
    }
    else if (trim === 'monthStart') {
        d = d.startOf('month');
    }
    else if (trim === 'monthEnd') {
        d = d.endOf('month');
    }
    if (earliestTime) {
        d = compareTimes(dayjs(earliestTime), d)[1];
    }
    if (latestTime) {
        d = compareTimes(dayjs(latestTime), d)[0];
    }
    if (returnString) {
        return time2utc(d);
    }
    else {
        return d;
    }
});
